const products = {
  "Blue Denim Shirt | Classic Style & Everyday": 3000,
  "Blue Gingham check printShirt": 3000,
  "Blue Long Sleeve Check 100% Cotton Shirt": 8000,
  "Blue Long Sleeve Leaf Print 100% Cotton Shirt": 5000,
  "Blue Long Sleeve Two Pocket Shirt": 6000,
  "Blue Print Shirt": 4000,
  "Blue Stripe Linen Shirt": 6000,
  "Bold Men’s Zig-Wig Print Cotton Shirt – Elegant & Trendy": 4800,
  "Brown Short Sleeve Hibiscus Print Shirt": 7000,
  "Classic Men Printed Cotton Shirt – Effortlessly": 4600,
  "Dark Grey Long Sleeve Blyth Plain 100% Cotton": 6000,
  "Dark Grey Long Sleeve Cotton Shirt": 4000,
  "Formal Linen Cotton Shirt For Men": 3000,
  "Green Short Sleeve Jungle Print Shirt": 7000,
  "Grey Long Sleeve Grid Check 100% Cotton Shirt": 8000,
  "Light Grey Long Sleeve Geo Print 100% Cotton": 3000,
  "Light Vintage Blue Long Sleeve Sandy Check 100%": 8000,
  "Mead Blue Long Sleeve Check 100% Cotton Shirt": 7000,
  "Men’s No Iron Premium Comfort & Style Shirt": 4000,
  "Men’s Artistic Print Cotton Shirt – Creative & Unique": 4800,
  "Men’s Casual Printed Blocks Shirt – Comfortable & Stylish": 3000,
  "Men’s Printed Blocks Cotton Shirt – Premium": 4700,
  "Men’s Solid Color & Print Cotton Shirt – Stylish": 5000,
  "Men’s Stylish Casual “Haha” Printed Cotton": 4200,
  "Men’s Stylish Casual Alphabet Print Cotton": 4500,
  "Natural Dobby Cotton Stripe Shirt": 7000,
  "Orange 100% Cotton Long Sleeve Check Shirt": 8000,
  "Pink Long Sleeve Tring Check 100% Cotton Shirt": 5000,
  "Printed Blocks Shirt for Men – Premium Fabric & Stylish Design": 3600,
  "Purple Short Sleeve Trescott Stripe Shirt": 4000,
  "Red Leaf Print Short Sleeve Cotton Fabric Shirt": 5000,
  "Regular fit stripped linen shirt": 7000,
  "Sky Blue Formal Shirt for Men Classic & Professional": 5000,
  "Sky Blue Printed Short Sleeve Cotton Shirt": 8000,
  "Stone Long Sleeve Buffalo Check 100% Cotton Shirt": 4000,
  "Yellow and Blue Cotton Check Shirt": 6000,
  "Vintage Long Sleeve Hove Check Shirt – 100% Cotton": 5000,
  "90s Vintage Black Matte Glasses – 60s Design": 1000,
  "A9 Genuine Leather Refillable Planner": 700,
  "Authentic Vintage 90s Small Rectangle Gold": 1000,
  "Baby Blue Linen Suit Slim Fit Two Piece Set Wedding": 25000,
  "Baggy Denim Jeans – Brown | Stylish & Comfortable Everyday Wear": 8000,
  "Baggy Linen Pants Blue Striped": 4000,
  "Beach Ready Sunglasses – Stylish Protection for": 1400,
  "Beige Striped Baggy Linen Pants": 6000,
  "Black Heavy Knit Cropped T-Shirt for Men": 7000,
  "Black Ripstop Cargo Trousers": 6000,
  "Black Skinny Fit Suit Three Piece Set with Double": 31000,
  "Blue Bootcut Jeans": 6000,
  "Blue Cargo Trousers": 7000,
  "Blue Frame Reading Glasses – Stylish Eyewear": 900,
  "Blue Rocket Tie – A Stellar Accessory for Dreamers": 1600,
  "Blue Stylish Chinos Shorts Slim Fit": 2500,
  "Blue Wolf Tie – Bold and Majestic Design for Any": 2300,
  "Brick Red Skinny Fit Suit Three Piece Set Wedding": 26000,
  "Brown Hybrid Fit Suit Wedding Prom": 26000,
  "Burgundy Double Breasted Suit Two Piece": 27000,
  "Burgundy Flower Pin – Dainty Lapel Pin for Men": 600,
  "Burgundy Suit Three Piece Set Wedding Prom": 49999,
  "Casual Printed Cord Set for Any Occasion": 10500,
  "Checkered Pajama Pants for Men": 7000,
  "Chic Printed Shirt and Matching Shorts": 11000,
  "Comfortable Printed Shirt and Shorts Combo": 9500,
  "Dark Blue Pin Stripe Suit Three Piece Set Wedding": 24000,
  "Dark Brown Check Overshirt": 5000,
  "Denim Jeans – Indigo Timeless Style & Superior": 6000,
  "Denim Jeans Light Blue": 5000,
  "Dusky Green Long Sleeve Neath Check 100% Cotton": 6000,
  "Dusty Rose Skinny Fit Suit Three Piece Set Wedding": 26000,
  "Eco-Friendly Recycled Fabric Cargo Pants": 4000,
  "Protected: Fern Apple Green Men’s Tie": 1500,
  "Flared Cargo Pants": 4000,
  "Gentle Blush Magnolia Lapel Pin – Elegant": 400,
  "Grading Pink Ombre Rose Lapel Pin – Elegant Garden Wedding": 300,
  "Green Cuffed Cargo Trousers": 5000,
  "Green Skinny Fit Suit Three Piece Set Separates": 25000,
  "Green Straight Cargo Trousers": 8000,
  "Green Straight Fit Barton Jeans": 7000,
  "Grey Plaid Three Piece Suit Wedding Prom": 20000,
  "Handmade Pink Rose Lapel Pin - Elegant": 500,
  "Handmade Red Rose Lapel Pin - Unique": 300,
  "Ivory Pink Ombre Boutonniere - Stylish": 600,
  "Ivory Satin Pink Bow Tie - Elegant & Stylish for Any Formal Occasion": 1100,
  "Leather Money Clip Wallet - Minimalist Wallet for Men": 700,
  "Light Blocking Photochromic Transition": 1200,
  "Light Brown Skinny Fit Suit Three Piece Set Wedding": 30000,
  "Light Grey Pinstripe Hybrid Fit Suit Wedding": 26000,
  "Lion Cufflink Set in 14k Gold Finish - Majestic": 4500,
  "Loose Fit Black Waist Linen Pants": 4000,
  "Loose Fit Wide Leg Denim Jeans": 9000,
  "Luxury Gradient Sunglasses - Subtle": 3500,
  "Men Black Solid Color Lapel Neck Short Sleeve": 11500,
  "Men's Printed Blue T-shirt": 2000,
  "Men's Long-Sleeve Grid Waffle Cropped Tee": 3000,
  "Men's Long Plain Chino Shorts": 2000,
  "Men's 7″ Utility Shorts - Versatile and Durable": 1200,
  "Men's Black Skull Necktie - Bold & Stylish": 1900,
  "Men's Blue Medallion Tie - Elegant & Timeless Design": 3100,
  "Men's Green Floral Tie - Vibrant & Stylish": 1800,
  "Men's Sage Wool Necktie - Elegant & Sophisticated": 2400,
  "Navy Men's Tie with Triceratops Dinosaur - Quirky and Stylish Design": 1500,
  "Personalized Vintage Leather Wallet - Engraved Custom Wallet": 700,
  "Pink Ombre Brooch - Wedding or Formal Event": 500,
  "Printed Shirt and Boxer Cord Set for Vacations": 12000,
  "Pyjamas Pants Brown": 7500,
  "Pyjamas Pants white": 5500,
  "Red Peony Boutonniere for Men - Wedding Floral": 600,
  "Red Windowpane Check ShirtHeavy Fabric witer": 3000,
  "Relaxed Printed Shirt and Shorts Duo": 12000,
  "Retro Japanese Style Lightweight Small Round": 900,
  "Round Reading Glasses - Comfortable and Stylish": 1000,
  "Rust Brown T-Shirt": 3000,
  "Sand-Colored Rose Lapel Pin - Elegant Wedding": 400,
  "skinny black denim low waist jeans": 6000,
  "Small Square Rectangular Sunglasses for Men - Stylish Eyewear": 1300,
  "Smart Printed Shirt and Boxer Outfit": 14000,
  "Stylish Navy Tie with Embroidered T-Rex": 2000,
  "Suit Pants Brown for Men": 4000,
  "Summer Mint Lapel Pin - Pastel Green & Blue": 300,
  "Tan Linen Suit Slim Fit Two Piece Se Wedding Prom": 27000,
  "Verge Glasses - Futuristic Eyewear": 1200,
  "Vintage Square Aviator Glasses – 70s Silver": 1100,
  "Vintage Square Aviator Glasses – 70s Style Black": 800,
  "Wallet Personalized Men’s Wallet": 500,
  "Vintage Sunglasses for Men – Retro Style": 900,
  "White Lapel Pin with Green Leaves – Elegant": 400,
  "Wide Leg Trousers For Men": 4000,
  "White Half-Sleeve T Shirt Classic, Versatile & Comfortable": 5000,
};

const orgDetails = {
  orgName: "",
  phoneNumber: "",
  gstNumber: "",
  orgAddress: "",
};

const shortName = "RT";

const seltous = { products, orgDetails, shortName };
export default seltous;
